//- SCRIPTS DO ESPECIAL

$(function () {
    var $general = $('#general-special'),
        answers = [true, true, false, false, false, true, false, true, true, true, false, true],
        sendAnswers = [],
        $quiz = $('section.quiz', $general).html(),
        $numberQuestions = $('.question-block', $general).length;

    var eventLoop = function() {
        $('.custom-video.start video', $general).each(function(index, elem) {
            elem.addEventListener('timeupdate', function () {
                if (this.currentTime >= 3) {
                    openQuestion($(elem).parents('.custom-video').siblings('.question'))
                }
            }, false);

            elem.addEventListener('ended', function() {
                elem.load();
            })
        });

        $('.custom-video.answer video', $general).each(function(index, elem) {
            var $parentIndex = $(this).parents('.question-block').index();

            elem.addEventListener('ended', function() {
                console.log($numberQuestions);
                if ($parentIndex < $numberQuestions - 1) {
                    openVideo($parentIndex + 1);
                } else {
                    showResult($(this).parents('.question-block').find('.custom-video.answer video').get(0));
                }
            }, false)
        });
    }

    var openQuestion = function(elem) {
        var $elem = elem;

        $elem.addClass('active');
    }

    var openVideo = function(index) {
        var $quiz = $('section.quiz', $general),
            $questionBlock = $('.question-block').eq(index),
            $video = $('.custom-video.start video', $questionBlock),
            promise = $video.get(0).play(),
            $siblings = $questionBlock.siblings(),
            $prevVideo = $questionBlock.prev().find('.custom-video.answer video'),
            $nextQuestion = $questionBlock.next().find('.custom-video.start video'),
            $nextAnswer = $questionBlock.next().find('.custom-video.answer video');

        if ($nextQuestion.length) {
            for (var i = 0; i <= 2; i++) {
                var type,
                    $sourceQuestion = document.createElement('source'),
                    $sourceAnswer = document.createElement('source'),
                    urlQuestion,
                    urlAnswer;

                if (i == 0) {
                    type = 'video/webm';
                    if ($(window).width() <= 1024) {
                        urlQuestion = $nextQuestion.data('url') + '-mobile.webm';
                        urlAnswer = $nextAnswer.data('url') + '-mobile.webm';
                    } else {
                        urlQuestion = $nextQuestion.data('url') + '.webm';
                        urlAnswer = $nextAnswer.data('url') + '.webm';
                    }
                } else if (i == 1) {
                    type = 'video/mp4';
                    urlQuestion = $nextQuestion.data('url') + '.mp4';
                    urlAnswer = $nextAnswer.data('url') + '.mp4';
                } else if (i == 2) {
                    type = 'video/ogg';
                    urlQuestion = $nextQuestion.data('url') + '.ogv';
                    urlAnswer = $nextAnswer.data('url') + '.ogv';
                }

                $sourceQuestion.src = urlQuestion;
                $sourceAnswer.src = urlAnswer;
                $sourceQuestion.type = type;
                $sourceAnswer.type = type;

                $nextQuestion.append($sourceQuestion);
                $nextAnswer.append($sourceAnswer);
            }
        }

        if (promise !== null){
            promise.catch(function(){ $video.get(0).play(); })
        }

        $video.parent().addClass('active');

        $questionBlock.addClass('active open');
        $siblings.removeClass('active');

        if ($prevVideo.length) {
            $prevVideo.get(0).pause()
            $prevVideo.remove()
        }
    }

    var openQuiz = function() {
        $('section.init', $general).removeClass('active');
        $('section.quiz', $general).addClass('active');
        openVideo(0)
    }

    var showResult = function(lastVideo) {
        lastVideo.pause();
        $('section.result').addClass('active').siblings().removeClass('active');
        countCorrect();
    }

    var verifyAnswer = function(question, elem) {
        var value = elem.data('value'),
            $video = $('.custom-video.answer', $('.question-block').eq(question)),
            promise = $video.find('video').get(0).play();

        if (value == answers[question]) {
            elem.addClass('hit');
            markQuestion(question, 'correct');
        } else {
            elem.addClass('missed');
            markQuestion(question, 'wrong');
        }

        if (promise !== null){
            promise.catch(function(){
                $video.find('video').get(0).play();
            })
        }

        $video.addClass('active').siblings('.custom-video').removeClass('active').find('video').get(0).pause();

        setTimeout(function(){
            $video.siblings('.custom-video').removeClass('active').find('video').get(0).remove();
        }, 600);

        $('.question', $('.question-block').eq(question)).addClass('hide-progress');

        setTimeout(function(){
            elem.parents('.detail').removeClass('active');
            elem.parents('.detail').siblings('.next-question, .show-result').addClass('active');
        }, 5000);
    }

    var markQuestion = function(index, answer) {
        $('section.result .card li', $general).eq(index).addClass(answer);
    }

    var countCorrect = function() {
        $('section.result .number-correct').text($('section.result ul li.correct').length);
    }

    var generateImage = function() {
        $('section.result .card').addClass('image');

        html2canvas(document.querySelector('section.result .card'), {
            useCORS: true,
            logging: false,
            scale: 2.5
        }).then(function(canvas) {
            var image = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
            var a = document.createElement('a');
            a.href = image;
            a.download = 'resultado.jpg';
            a.click();
            $('section.result .card').removeClass('image');
        });
    }

    // EVENTS
    $('.open-quiz', $general).on('click', function() {
        openQuiz();
    })

    $('.init-again', $general).on('click', function() {
        $('section.quiz', $general).html($quiz);
        $('section.init', $general).addClass('active');
        $('section.result', $general).removeClass('active');
        $('section.result ul li').removeClass('correct wrong');
        eventLoop();

        $('html, body').animate({
            scrollTop: 0
        }, 300)
    })

    $('main', $general).on('click', '.question .detail button', function() {
        verifyAnswer($(this).parents('.question-block').index(), $(this));
    })

    $('main', $general).on('click', '.next-question', function() {
        var index = $(this).parents('.question-block').index();

        openVideo(++index);
    })

    $('main', $general).on('click', '.question .show-result', function() {
        showResult($(this).parents('.question-block').find('.custom-video.answer video').get(0));
    })

    $('.download-image', $general).on('click', function() {
        generateImage();
    })

    // INIT
    setTimeout(function() {
        $general.removeClass('loading');
        eventLoop();
    }, 7000);
});
